<template>
  <ion-modal :is-open="isOpen" @didDismiss="$emit('close')" :backdrop-dismiss="true" class="card-modal">
    <ion-card>
      <ion-card-header>
        <ion-card-title>{{ levelKey }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-button @click="handlePlay" expand="block">Play Again</ion-button>
        <ion-button @click="handleReplaySolution" expand="block" fill="outline">Show My Solution</ion-button>
        <ion-button @click="$emit('close')" expand="block" color="light">Back</ion-button>
      </ion-card-content>
    </ion-card>
  </ion-modal>
</template>

<script setup>
import {
  IonModal,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonButton,
} from '@ionic/vue';

const props = defineProps({
  isOpen: Boolean,
  levelKey: String,
});

const emit = defineEmits(['close', 'play', 'replay-solution']);

const handlePlay = () => {
  emit('play');
  emit('close');
};

const handleReplaySolution = () => {
  emit('replay-solution');
  emit('close');
};
</script>

<style scoped>
ion-card {
  --background: var(--hw-bg-surface);
  --color: var(--hw-text);
  text-align: center;
  padding: 20px;
}
</style>
